import { render, staticRenderFns } from "./FacilityList.vue?vue&type=template&id=61a6ffbc&"
import script from "./FacilityList.js?vue&type=script&lang=js&"
export * from "./FacilityList.js?vue&type=script&lang=js&"
import style0 from "./FacilityList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
